var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '../../../../../components';
import { AiOutlineClose } from '../../../../../icons';
export var InputControlClearable = function (_a) {
    var clearable = _a.clearable, onClear = _a.onClear;
    if (!clearable)
        return null;
    return _jsx(_Fragment, { children: _jsx("div", { children: _jsx(Button, __assign({ noneTheme: true, flat: true, noFocuseable: true, borderRadius: 5, padding: 2, minHeight: 0, onClick: onClear, buttonSize: "free", size: 24 }, { children: _jsx(AiOutlineClose, { size: 16 }) })) }) });
};
